import { styled } from "@shoothill/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";
import { InductionAdminNonConformanceViewModel } from "./InductionAdminNonConformanceListViewModel";
import { InductionAdminNonConformanceTableView } from "./InductionAdminNonConformanceTableView";

interface IProps {
    className?: string;
    inductionUserId: string;
}

const InductionAdminNonConformanceViewBase: React.FC<IProps> = (props) => {
    const { inductionUserId } = props;
    const [listViewModel] = useState(() => new InductionAdminNonConformanceViewModel(inductionUserId));
    // #region Code Behind

    const renderPage = () => {
        return (
            <InductionAdminNonConformanceTableView handleRowClick={listViewModel.handleRowClick} isLoading={listViewModel.IsLoading} data={listViewModel.nonConformanceListItems} />
        );
    };

    return useObserver(() => renderPage());
};

export const InductionAdminNonConformanceView = styled(InductionAdminNonConformanceViewBase)``;
